import React from 'react';

import { Paper, TextInput, Title, createStyles } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';

const useStyles = createStyles(theme => ({
  header: {
    padding: theme.spacing.lg,
    background: theme.colors.gray[0],
    borderRadius: 0,
    borderBottom: `1px solid ${theme.colors.gray[3]}`,
    display: 'grid',
    gridTemplateColumns: 'auto 400px',
    gridTemplateRows: 'auto',
    gridTemplateAreas: `"title search"`,
    alignItems: 'center',
    gap: theme.spacing.sm,
    [theme.fn.smallerThan('md')]: {
      gridTemplateColumns: 'auto',
      gridTemplateRows: 'auto auto',
      gridTemplateAreas: `
        'title'
        'search'
      `,
    },
  },
  title: {
    gridArea: 'title',
  },
  search: {
    gridArea: 'search',
  },
}));

const AdminGymPageHeader = ({
  search,
  setSearch,
}: {
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
}): JSX.Element => {
  const { classes } = useStyles();
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.currentTarget?.value || '';
    setSearch(value);
  };
  return (
    <Paper className={classes.header}>
      <Title order={1} size='h1' className={classes.title}>
        Gyms
      </Title>
      <TextInput
        className={classes.search}
        icon={<IconSearch />}
        placeholder='Search by Gym or Owner'
        value={search}
        onChange={handleSearchChange}
        style={{ gridArea: 'search' }}
      />
    </Paper>
  );
};

export default AdminGymPageHeader;
